import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider as BaseThemeProvider } from 'styled-components'
import theme from '../../styles/theme'

/**
 * The ThemeProvider's component.
 */
const ThemeProvider = props => {
  const { children } = props

  return <BaseThemeProvider theme={theme}>{children}</BaseThemeProvider>
}

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default ThemeProvider
